import { SessionStatus } from '@/types';

import {
  actionUser,
  appointmentSessionKind,
  canRenderNativeJoin,
} from './appointmentActionSession';

import type { AdminAppointment } from './types';
import type { Session } from '@/types';

const adminActionUser = (
  identity: AdminAppointment['expectedIdentities']['coach'],
): Session['coach'] => ({
  ...actionUser(identity),
  id: identity.railsUserId,
});

export interface AdminAppointmentActionSessionOptions {
  readOnly?: boolean;
}

export const adminAppointmentActionSession = (
  appointment: AdminAppointment,
  { readOnly = true }: AdminAppointmentActionSessionOptions = {},
): Session =>
  ({
    bookId: `moments:${appointment.id}`,
    bookingSource: 'moments',
    coach: adminActionUser(appointment.expectedIdentities.coach),
    coachId: appointment.expectedIdentities.coach.railsUserId,
    createdAt: appointment.baselineSchedule.startAt,
    endedAt: appointment.currentSchedule.endAt,
    id: appointment.id,
    isChemistryCall: appointment.kind === 'chemistry',
    kind: appointmentSessionKind(appointment),
    location: canRenderNativeJoin(appointment)
      ? (appointment.meeting.joinUrl ?? undefined)
      : undefined,
    recurringId: appointment.seriesId ?? '',
    slug: appointment.kind,
    sourceAppointmentCancelAllowed: readOnly
      ? false
      : appointment.actionCapabilities.cancel.allowed &&
        appointment.actionCapabilities.cancel.scopes.includes('appointment'),
    sourceAppointmentCancelReasonRequired: readOnly
      ? false
      : appointment.actionCapabilities.cancel.reasonRequired,
    sourceAppointmentCancelScopes: readOnly
      ? []
      : appointment.actionCapabilities.cancel.scopes,
    sourceAppointmentId: appointment.id,
    sourceAppointmentIdentityScheme: 'rails-user',
    sourceAppointmentRescheduleAllowed: readOnly
      ? false
      : appointment.actionCapabilities.reschedule.allowed &&
        appointment.actionCapabilities.reschedule.scopes.includes(
          'appointment',
        ),
    sourceAppointmentRescheduleScopes: readOnly
      ? []
      : appointment.actionCapabilities.reschedule.scopes,
    sourceAppointmentSeriesId: appointment.seriesId,
    sourceAppointmentSeriesMutationVersion: appointment.seriesMutationVersion,
    sourceAppointmentVersion: appointment.version,
    startedAt: appointment.currentSchedule.startAt,
    status: SessionStatus.ACTIVE,
    title:
      appointment.kind === 'chemistry' ? 'Chemistry Call' : 'Coaching Session',
    user: adminActionUser(appointment.expectedIdentities.member),
    userId: appointment.expectedIdentities.member.railsUserId,
  }) as Session;
